import axios, { AxiosResponse } from 'axios';
import getApiBaseUrl from '../GetServer';

export interface RolePermission {
  idRol: number;
  roleName: string;
  statusRole: number;
  tienePermiso: number;
  action: string | null;
  actionId: number; // Propiedad añadida
}

export const getRoles = async (): Promise<RolePermission[]> => {
  try {
    const baseUrl = getApiBaseUrl();
    const endpoint = `${baseUrl}dash/roles`;

    const token = localStorage.getItem('token');

    if (!token) {
      throw new Error('Token no disponible');
    }

    const response: AxiosResponse<{
      status: number;
      message: string;
      data: RolePermission[];
    }> = await axios.post(endpoint, {}, {
      headers: {
        'Authorization': `Bearer ${token}`
      }
    });

    if (response.data.status !== 200) {
      throw new Error(response.data.message);
    }

    return response.data.data;
  } catch (error) {
    console.error('Error fetching roles:', error);
    throw error;
  }
};